export enum VideoProviderEnum {
    DAILYMOTION = 'dailymotion',
    FACEBOOK = 'facebook',
    VIMEO = 'vimeo',
    YOUTUBE = 'youtube',
}
